import { call, put, takeLatest } from "redux-saga/effects";
import apiClient from "../../api/apiClient";
import {
  createCultureSuccess,
  createCultureFailure,
  createCultureStart,
  deleteCultureFailure,
  deleteCultureStart,
  deleteCultureSuccess,
  updateCultureSuccess,
  updateCultureFailure,
  updateCultureStart,
} from "../../store/features/culture/cultureSlice";
import { fetchCropsStart } from "../../store/features/crops/cropsSlice";

const relativeUrl = "/api/v1/colture/colture/";

// CREATE
const createCultureApi = async ({ data, accessToken }) => {
  try {
    const client = apiClient(accessToken, relativeUrl);
    const response = await client.post("/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleCreateCultureSaga(action) {
  try {
    const data = yield call(createCultureApi, action.payload);
    yield put(createCultureSuccess(data));
  } catch (error) {
    yield put(createCultureFailure(error));
  }
}

// UPDATE
const updateCultureApi = async ({ data, accessToken, cultureId }) => {
  try {
    const client = apiClient(accessToken, relativeUrl);
    const response = await client.put(`${cultureId}/`, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleUpdateCultureSaga(action) {
  try {
    const data = yield call(updateCultureApi, action.payload);
    yield put(updateCultureSuccess(data));
  } catch (error) {
    yield put(updateCultureFailure(error.message));
  }
}

// DELETE
const deleteCultureApi = async ({ accessToken, userId }) => {
  try {
    const client = apiClient(accessToken, relativeUrl);
    const response = await client.delete(`/${userId}/`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleDeleteCultureSaga(action) {
  try {
    const data = yield call(deleteCultureApi, action.payload);
    yield put(deleteCultureSuccess(data));
    yield put(fetchCropsStart({ accessToken: action.payload.accessToken }));
  } catch (error) {
    yield put(deleteCultureFailure(error.message));
  }
}

export default function* cultureSaga() {
  yield takeLatest(createCultureStart.type, handleCreateCultureSaga);
  yield takeLatest(deleteCultureStart.type, handleDeleteCultureSaga);
  yield takeLatest(updateCultureStart.type, handleUpdateCultureSaga);
}
